export interface Address {
    name?: string;
    line1?: string;
    line2?: string;
    city?: string;
    countryCode?: string;
    regionCode?: string;
    zipCode?: string;
}
